function capitalizeEachWord(str) {
  // Extracted from http://alvinalexander.com/javascript/how-to-capitalize-each-word-javascript-string
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function getSemanticKey(isEstadual, semanticData) {
  const key = isEstadual
    ? semanticData.semantic.state.toLowerCase()
    : semanticData.semantic.uri;

  return key;
}

function secondsToMilliseconds(seconds) {
  return seconds * 1000;
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList);
}

const cityIsValid = function (data) {
  return (
    data &&
    data.semantic &&
    data.semantic.uri &&
    data.semantic.region &&
    data.semantic.state &&
    data.semantic.city
  );
};

const ABRANGENCIAS_2_TURNO = [
  'SP',
  'RJ',
  'MG',
  'AP',
  'AM',
  'DF',
  'MS',
  'PA',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SE',
];

const abrangenciaIsValid = function (data) {
  return (
    cityIsValid(data) &&
    ABRANGENCIAS_2_TURNO.indexOf(data.semantic.state.toUpperCase()) !== -1
  );
};

const isMobile = (function () {
  var mediumMaxWidth = '62.4375em';
  return window.matchMedia('(max-width: ' + mediumMaxWidth + ')').matches;
})();

const formataData = function (data) {
  const valores = data.split('-'),
    ano = valores[0],
    mes = valores[1],
    dia = valores[2];
  return dia + '/' + mes + '/' + ano;
};

const formataPorcentagem = function (numero) {
  let porcentagem = '' + numero;
  porcentagem = porcentagem.replace('.', ',');
  if (porcentagem.indexOf('%') === -1) {
    porcentagem += '%';
  }
  return porcentagem;
};

const inserirPontuacaoMilhar = function (valor) {
  return valor.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1.');
};

function waitUntil(checkCallback, timeout=15) {
  const wait_interval = 500,
    wait_limit = timeout * 2 - 2;

  let wait_count = 0;

  return new Promise((resolve, reject) => {
    function wait() {
      if (checkCallback()) {
        return resolve();
      } else if (wait_count >= wait_limit) {
        return reject();
      } else {
        wait_count ++;
        setTimeout(wait, wait_interval);
      }
    }
    wait();
  });
}

export {
  capitalizeEachWord,
  getSemanticKey,
  nodeListToArray,
  cityIsValid,
  isMobile,
  formataData,
  inserirPontuacaoMilhar,
  formataPorcentagem,
  abrangenciaIsValid,
  secondsToMilliseconds,
  waitUntil
};
